"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Cards = function (_a) {
    var plans = _a.plans;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-subscription-cards', "storybook-subscription-cards-" + plans.length) }, plans.map(function (plan, index) { return react_1.default.createElement(storybook_1.Subscriptions.Card, { key: index, plan: plan }); }));
};
exports.Cards = Cards;
